import { authenticationConstants } from '../constants';

import { func_validation, func_cookie } from 'functions';

export function authenticationReducers(state = {}, action) {
    const { monitorTokenInterval } = state;

    let monitorTokenInterval_formatted = monitorTokenInterval;

    switch (action.type) {
            
        // Login
        
        case authenticationConstants.login_request:
            return {
                ...state,
                login_requesting: true, login_status: false,
                isLoggedIn: undefined,
                userInfo: undefined,
                login_errorMsg: undefined,
            }
        case authenticationConstants.login_success:
            // Set token in cookie
            let isEveryTokenSetSuccessfully = setTokens(action);
            
            // Monitor refresh token validity
            monitorTokenInterval_formatted = setInterval(() => { 
                let refreshToken = func_cookie.getCookieValue("refresh_token_bp");
                if (func_validation.isStringTrimEmpty(refreshToken)) {
                    clearInterval(monitorTokenInterval_formatted);
                }
            }, 3000);

            return {
                ...state,
                login_requesting: false, login_status: true,
                isLoggedIn: isEveryTokenSetSuccessfully,
                monitorTokenInterval: monitorTokenInterval_formatted,
                login_errorMsg: undefined,
            }
        case authenticationConstants.login_failure:
            return {
                ...state,
                login_requesting: false, login_status: false, 
                isLoggedIn: false,
                login_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

        // Refresh Access Token
        
        case authenticationConstants.refreshAccessToken_request:
            return {
                ...state,
                refreshAccessToken_requesting: true, refreshAccessToken_status: false,
                refreshAccessToken_errorMsg: undefined,
            }
        case authenticationConstants.refreshAccessToken_success:
            // Set token in cookie
            setTokens(action);

            return {
                ...state,
                refreshAccessToken_requesting: false, refreshAccessToken_status: true,
                refreshAccessToken_errorMsg: undefined,
            }
        case authenticationConstants.refreshAccessToken_failure:
            return {
                ...state,
                refreshAccessToken_requesting: false, refreshAccessToken_status: false, 
                refreshAccessToken_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

        // Generate Email OTP
        
        case authenticationConstants.generateEmailOTP_request:
            return {
                ...state,
                generateEmailOTP_requesting: true, generateEmailOTP_status: false,
                generateEmailOTP_errorMsg: undefined,
            }
        case authenticationConstants.generateEmailOTP_success:
            return {
                ...state,
                generateEmailOTP_requesting: false, generateEmailOTP_status: true,
                generateEmailOTP_errorMsg: undefined,
            }
        case authenticationConstants.generateEmailOTP_failure:
            return {
                ...state,
                generateEmailOTP_requesting: false, generateEmailOTP_status: false, 
                generateEmailOTP_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

        // Reset Password
        
        case authenticationConstants.resetPassword_request:
            return {
                ...state,
                resetPassword_requesting: true, resetPassword_status: false,
                resetPassword_errorMsg: undefined,
            }
        case authenticationConstants.resetPassword_success:
            return {
                ...state,
                resetPassword_requesting: false, resetPassword_status: true,
                resetPassword_errorMsg: undefined,
            }
        case authenticationConstants.resetPassword_failure:
            return {
                ...state,
                resetPassword_requesting: false, resetPassword_status: false, 
                resetPassword_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

        // Logout
        
        case authenticationConstants.logout_request:
            return {
                ...state,
                logout_requesting: true, logout_status: false,
            }
        case authenticationConstants.logout_success:
            clearInterval(monitorTokenInterval_formatted);
            func_cookie.removeCookie("access_token_bp", { path: "/" });
            func_cookie.removeCookie("refresh_token_bp", { path: "/" });

            return {
                ...state,
                logout_requesting: false, logout_status: true,
                userInfo: undefined,
                isLoggedIn: false
            }
        case authenticationConstants.logout_failure:
            return {
                ...state,
                logout_requesting: false, logout_status: false,
            }

        // Get User Info
        
        case authenticationConstants.getUserInfo_request:
            return {
                ...state,
                getUserInfo_requesting: true, getUserInfo_status: false,
                getUserInfo_errorMsg: undefined,
            }
        case authenticationConstants.getUserInfo_success:
            return {
                ...state,
                getUserInfo_requesting: false, getUserInfo_status: true,
                userInfo: action.details.data,
                getUserInfo_errorMsg: undefined,
            }
        case authenticationConstants.getUserInfo_failure:
            return {
                ...state,
                getUserInfo_requesting: false, getUserInfo_status: false, 
                getUserInfo_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

        // Login Modal Visiblity
        case authenticationConstants.loginModalVisiblity:
            return {
                ...state,
                isLoginModalVisible: action.isModalVisible
            }

        default:
            return state;
    }
}

function setTokens(action) {
    let response = action?.details?.data;

    let access_token = func_validation.getObjectPropertyValue(response, "access_token");
    let access_token_expirationDate = func_validation.getObjectPropertyValue(response, "access_token_expires");
    let options = { 
        path: '/',
        sameSite: "strict",
        expires: new Date(access_token_expirationDate),
    };
    let isSetSuccessfully_accessToken = func_cookie.setCookie("access_token_bp", access_token, options);

    let refresh_token = func_validation.getObjectPropertyValue(response, "refresh_token");
    let refresh_token_expirationDate = func_validation.getObjectPropertyValue(response, "refresh_token_expires");
    options = { 
        path: '/',
        sameSite: "strict",
        expires: new Date(refresh_token_expirationDate),
    };
    let isSetSuccessfully_refreshToken = func_cookie.setCookie("refresh_token_bp", refresh_token, options);

    let isEveryTokenSetSuccessfully = isSetSuccessfully_accessToken && isSetSuccessfully_refreshToken;
    return isEveryTokenSetSuccessfully;
}